export const UPLOAD_ORIGIN = 'BeX Platform';

export const SUPPORTED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'application/json',
    'text/plain',
    'image/png',
    'image/jpeg',
    'image/bmp',
    'image/gif',
    'image/webp',
    'image/tiff',
    'image/x-icon',
    'image/vnd.microsoft.icon',
    'audio/flac',
    'audio/x-flac',
    'audio/mpeg',
    'audio/mp3',
    'audio/mp4',
    'audio/x-m4a',
    'audio/ogg',
    'audio/wav',
    'audio/x-wav',
    'audio/webm',
    'video/mp4',
    'video/mpeg',
    'video/ogg',
    'video/webm'
];